var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIphoneSignal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6953 3.17188C10.6953 2.61959 11.143 2.17188 11.6953 2.17188H12.6953C13.2476 2.17188 13.6953 2.61959 13.6953 3.17188V11.1719C13.6953 11.7242 13.2476 12.1719 12.6953 12.1719H11.6953C11.143 12.1719 10.6953 11.7242 10.6953 11.1719V3.17188Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6953 1.17187C15.6953 0.61959 16.143 0.171875 16.6953 0.171875H17.6953C18.2476 0.171875 18.6953 0.61959 18.6953 1.17188V11.1719C18.6953 11.7242 18.2476 12.1719 17.6953 12.1719H16.6953C16.143 12.1719 15.6953 11.7242 15.6953 11.1719V1.17187Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69531 6.67188C5.69531 6.11959 6.14303 5.67188 6.69531 5.67188H7.69531C8.2476 5.67188 8.69531 6.11959 8.69531 6.67188V11.1719C8.69531 11.7242 8.2476 12.1719 7.69531 12.1719H6.69531C6.14303 12.1719 5.69531 11.7242 5.69531 11.1719V6.67188Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.695312 9.17188C0.695312 8.61959 1.14303 8.17188 1.69531 8.17188H2.69531C3.2476 8.17188 3.69531 8.61959 3.69531 9.17188V11.1719C3.69531 11.7242 3.2476 12.1719 2.69531 12.1719H1.69531C1.14303 12.1719 0.695312 11.7242 0.695312 11.1719V9.17188Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneSignal);
export default __webpack_public_path__ + "static/media/iphone_signal.21904e7faa50ef81118f06fc153b2078.svg";
export { ForwardRef as ReactComponent };